<template lang="pug">
  .post-body
    p.post-body__content(
      ref="postContent"
      v-html="trimmedText"
      @click="trimText = !trimText"
      :class="{ 'post-body__content--trim': trimText && trimTextLength < text.length,'post-body__content--untrim': !trimText && trimTextLength < text.length}"
    )
</template>

<script>
export default {
  name: 'postBody',
  props: {
    text: {
      type: String,
      default: '',
    },
    network: {
      type: String,
      default: 'vk',
    },
  },
  data() {
    return {
      trimText: true,
      trimTextLength: 300,
      regex: /\[(.*?)\]/g,
      social: {
        vk: {
          domen: 'https://vk.com/',
        },
        fb: {
          domen: 'https://www.facebook.com/',
        },
        tw: {
          domen: 'https://twitter.com/',
        },
      },
    };
  },
  methods: {
    replaceByNetwork() {
      const matches = this.text.match(this.regex);

      if (matches) {
        const matchedValues = matches.map(match => match.replace('[', this.social[this.network].domen).replace(']', '')).join(' ');
        const matchedArray = matchedValues.split('|');
        const link = `<a href="${matchedArray[0]}" target="_blank">${matchedArray[1]}</a>`;
        this.text = this.text.replace(matches[0], link);
      }
    },
  },
  computed: {
    trimmedText() {
      this.replaceByNetwork();
      if (!this.trimText && this.trimTextLength < this.text.length) {
        return this.text;
      }
      if (this.trimText && this.trimTextLength > this.text.length) {
        return this.text;
      }
      return `${this.text.substring(0, this.trimTextLength)}`;
    },
  },
};
</script>

<style lang="stylus">
.post
  &-body
    line-height 1.5em
    flex-grow 1
    @media screen and (max-width 900px)
      margin-righ auto
      max-width 100%
      &--with-image
        max-width 80%
    &__content
      margin 0
      max-width 100%
      overflow hidden
      cursor pointer
      &--trim
        &:after
          content '... Подробнее'
          font-weight bold
          color #460303
      &--untrim
        &:after
          content 'Скрыть'
          font-weight bold
          margin-left .5em
          color #460303
    &__show-more
      cursor pointer
      font-weight bold
      color #460303
      margin 1em 0
@media print
{
    .no-print, .no-print *
    {
        display: none !important;
    }
}
</style>
